import { createSlice } from '@reduxjs/toolkit';

import { ICexChartPoint } from 'types/charts';

interface IChartsSliceState {
  cexKlines: ICexChartPoint[];
}
const chartsSliceInitialState: IChartsSliceState = {
  cexKlines: [],
};

const chartsSlice = createSlice({
  name: 'charts',
  initialState: chartsSliceInitialState as IChartsSliceState,
  reducers: {
    setCexKlines: (store, { payload }: { payload: ICexChartPoint[] }) => {
      store.cexKlines = payload;
    },
  },
});

export const { setCexKlines } = chartsSlice.actions;

export default chartsSlice.reducer;
